import "./dot-animation-keyframe.css";

import { cn } from "@/utils";

type TypingAnimationProps = {
  className?: string;
};

export const TypingAnimation = ({ className = "" }: TypingAnimationProps) => {
  return (
    <div className={cn("px-[1px] flex gap-[5px] h-4 items-end", className)}>
      {Array.from({ length: 3 }, (_, i) => (
        <div
          key={i}
          style={{ animationDelay: i * 110 + "ms" }}
          className="[animation-name:typingdots] [animation-timing-function:ease] [animation-iteration-count:infinite] [animation-duration:660ms] w-1.5 h-1.5 bg-blue-12 dark:bg-white rounded-full"
        ></div>
      ))}
    </div>
  );
};

export default TypingAnimation;
